<script>
import VerifyDobForm from "@/components/auth/VerifyDobForm.vue";

export default {
  components: { VerifyDobForm },
  name: "VerifyDob"
};
</script>
<template>
  <VerifyDobForm></VerifyDobForm>
</template>
